import common from '@page/common/js/common';
import { createApp, ref } from 'vue';

import BrandBtn from '@components/BrandBtn.vue';
import BrandList from '@page/brand/components/BrandListPC.vue';
import useGoToTop from '@global/composable/useGoToTop';
import useAxiosAPI from '@global/composable/api/useAxiosAPI';

const { getBrandFollowAPI } = useAxiosAPI();

const app = createApp({
  components: {
    BrandBtn,
    BrandList,
  },
  setup() {
    const brandList = ref([]);
    function getBrandFollow() {
      getBrandFollowAPI()
        .then((res) => {
          if (res.data.Code === 200) {
            if (res.data.Response) {
              for (let i = 0; i < res.data.Response.length; i++) {
                if (res.data.Response[i].Followed) {
                  brandList.value.push(res.data.Response[i]);
                }
              }
            }
          }
        })
        .catch((error) => {
          console.log(error);
        });
    }
    getBrandFollow();

    function updateBrandList() {
      brandList.value = [];
      getBrandFollow();
    }

    const { scrollAnimation } = useGoToTop();
    function scrollToLetter(id) {
      const brandGroup = document.querySelector('.brand-group');
      const brandHeight =
        brandGroup.offsetHeight - brandGroup.offsetHeight
          ? parseInt(
              window
                .getComputedStyle(brandGroup)
                .getPropertyValue('margin-bottom')
                .replace('px', ''),
            )
          : 0;
      const targetElement = document.querySelector(id);
      const appBrandPaddingTop = parseInt(
        window
          .getComputedStyle(document.querySelector('#app-brand'))
          .getPropertyValue('padding-top')
          .replace('px', ''),
      );
      const followTitleHeight = document.querySelector('#follow-title').offsetHeight;

      if (targetElement) {
        const countHeight =
          targetElement.getBoundingClientRect().top +
          window.pageYOffset -
          appBrandPaddingTop -
          followTitleHeight -
          brandHeight;

        scrollAnimation(countHeight, 100);
      }
    }

    return { brandList, updateBrandList, scrollToLetter };
  },
});

app.mount('#app-brand');
